export const CREATE_POST_DRAFT_REQUEST = 'post/DRAFT_CREATE_REQUEST';
export const CREATE_POST_DRAFT_SUCCESS = 'post/DRAFT_CREATE_SUCCESS';
export const CREATE_POST_DRAFT_FAILURE = 'post/DRAFT_CREATE_FAILURE';
